import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/Breadcrumb';

const CustomerView: React.FC = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const customer = location.state?.customer;
    const { t, i18n } = useTranslation('common');
    function handleBack(): void {
        navigate(`/admin/customer`);
    }
    const toolbarTemplate = () => {
        function handlePrint(): void {
            window.print();
        }

        return (
            <>
                <Button label={t('print')} icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                <Button label={t('back')} icon="pi pi-angle-right" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />
            </>
        );
    };

    return (
        <div>
            <div className='card-title'>
                <h5>{t('cust-form')}</h5>
                <BreadcrumbComponent />
            </div>
            <div className='card'>
                <Accordion activeIndex={0}>
                    <AccordionTab header={t('cust-info')}>
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>{t('register-date')}:</label>
                                <p>{customer.registrationDate || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('cust-code')}:</label>
                                <p>{customer.facilityCode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('customer-name')}:</label>
                                <p>{customer.fullName || "N/A"}</p>
                            </div>

                            <div className="field col-12 md:col-6">
                                <label>{t('mnemonic')}:</label>
                                <p>{customer.mnemonic || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('department')}:</label>
                                <p>{customer.departmentCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('cust-type')}:</label>
                                <p>{customer.customerTypeHasOne.fullDesc || "N/A"}</p>
                            </div>
                        </div>
                    </AccordionTab>
                    <AccordionTab header={t('contact-info')}>
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>{t('address')}:</label>
                                <p>{customer.address1 || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('postcode')}:</label>
                                <p>{customer.postcode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('city')}:</label>
                                <p>{customer.city || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('country')}:</label>
                                <p>{customer.countryCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('state')}:</label>
                                <p>{customer.stateCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('district')}:</label>
                                <p>{customer.districtCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('tel-no')}:</label>
                                <p>{customer.telephoneNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('fax-no')}:</label>
                                <p>{customer.faxNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>{t('email')}:</label>
                                <p>{customer.email || "N/A"}</p>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>
            <Toolbar end={toolbarTemplate}></Toolbar>
        </div>
    );
};

export default CustomerView;